import React from 'react';
import './BannerComponent.css';

const banner = [
  { image: '1.jpg', name: 'RAMALINGAPPA DANNURE' },
  { image: '2.jpg', name: 'RAJ KUMAR RUDRA' },
  { image: '3.jpg', name: 'BHIMASHANKAR BANDE' },
  { image: '4.jpg', name: 'CHANNABASAVARAJ DANNURE' },
  { image: '5.jpg', name: 'SHIVUKUMAR DANAYI' },
  { image: '6.jpg', name: 'MAHESH HATTE' },
  { image: '7.jpg', name: 'GANGADHAR KUMBAR' },
  { image: '8.jpg', name: 'MOULA NIMBALKAR' },
  { image: '9.jpg', name: 'MITHUN KALMANE' },
  { image: '10.jpg', name: 'KIRAN BANGARAGE' },
  { image: '11.jpg', name: 'SIDRAMAPPA LENDE' },
];

const BannerComponent = () => {
  const president = [banner[0]];
  const vicePresident = [banner[1]];
  const secretary = [banner[10]];
  const administrationOfficer = [banner[6]];
  const boardOfDirectors = banner.slice(2, 6).concat(banner.slice(7, 10));

  const renderCard = (item, role, index) => (
    <div key={index} className="card">
      <img
        src={require(`./banner/${item.image}`)}
        alt={`${role} ${index + 1}`}
        className="responsive-img mb-4"
      />
      <h3>{item.name}</h3>
    </div>
  );

  return (
    <div className="banner-wrapper">
      <div className="container">
        {/* PRESIDENT & VICE PRESIDENT */}
        <div className="flex-row">
          <div className="flex-1 text-center">
            <h2 className="section-title">PRESIDENT</h2>
            {president.map((item, idx) => renderCard(item, 'President', idx))}
          </div>
          <div className="flex-1 text-center">
            <h2 className="section-title">VICE PRESIDENT</h2>
            {vicePresident.map((item, idx) => renderCard(item, 'Vice President', idx))}
          </div>
        </div>

        {/* SECRETARY & EXECUTIVE ADMINISTRATOR */}
        <div className="flex-row">
          <div className="flex-1 text-center">
            <h2 className="section-title">SECRETARY</h2>
            {secretary.map((item, idx) => renderCard(item, 'Secretary', idx))}
          </div>
          <div className="flex-1 text-center">
            <h2 className="section-title">EXECUTIVE ADMINISTRATOR</h2>
            {administrationOfficer.map((item, idx) => renderCard(item, 'Admin Officer', idx))}
          </div>
        </div>

        {/* BOARD OF DIRECTORS */}
        <h2 className="section-title with-underline">BOARD OF DIRECTORS</h2>
        <div className="grid-4">
          {boardOfDirectors.map((item, idx) => renderCard(item, 'Director', idx))}
        </div>
      </div>
    </div>
  );
};

export default BannerComponent;
